import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { first, Observable, Subject, switchMap } from 'rxjs';

import { AUTH_TOKEN } from '../../common/auth/auth-token.interceptor';
import { AuthService } from '../../common/auth/auth.service';
import { AbstractFetchAdaptor } from '../../common/fetch/abstract-fetch.adaptor';
import { AssessmentFormResponse } from './screening-tool-form.adaptor';

export interface AssessmentProps {
  id: number;
}

export interface AssessmentResponse {
  id: number;
  distress_score: number;
  other_comment: string;
  top_topic_ids: number[];
  top_needs: string[];
  respondent_role: string;
  relationship_to_survivor: string;
  assessment_sections: {
    id: number;
    section_id: number;
    comment: string;
    topic_ids: number[];
  }[];
}

@Injectable()
export class AssessmentFetchAdaptor extends AbstractFetchAdaptor<AssessmentProps, AssessmentFormResponse> {
  override name = 'assessment-fetch';

  private http = inject(HttpClient);
  private auth = inject(AuthService);

  data$ = new Subject<AssessmentFormResponse>();

  override onRequest(props: AssessmentProps): Observable<AssessmentFormResponse> {
    return this.auth.token$.pipe(
      first(),
      switchMap((token) =>
        this.http.get<AssessmentFormResponse>(`/assessments/${props.id}.json`, {
          context: new HttpContext().set(AUTH_TOKEN, token),
        }),
      ),
    );
  }

  override onSuccess(_props: AssessmentProps, res: AssessmentFormResponse) {
    this.data$.next(res);
  }
}
